import { Container } from "@mui/material";
import React from "react";
import { Box, Button, Grid, Link, TextField } from "@mui/material";
import { styled } from "@mui/material/styles";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Sella from "./Sella.png";
import { useState, useEffect } from "react";
import Url from "../services/Url";
import axios from "axios";
import { useSharedStore } from "../services/SharedStore";
import { useNavigate } from "react-router-dom";
import "../cssPages/Logo.css";
import "../cssPages/Line.css";





const HelperText = styled(Box)({
  marginTop: "168px",
  fontFamily: "Lato",
  fontSize: "13px",
  fontWeight: "normal",
  fontStretch: "normal",
  fontStyle: "normal",
  lineHeight: "1.54",
  letterSpacing: "0.09px",
  textAlign: "center",
  color: "#919191",
});

const ContactLink = styled(Link)({
  fontFamily: "Lato",
  fontSize: "13px",
  fontWeight: "bold",
  fontStretch: "normal",
  fontStyle: "normal",
  lineHeight: "1.54",
  letterSpacing: "0.09px",
  textAlign: "center",
  color: "#00cb4d",
});

const Informativa = styled(Box)({
  marginBottom: '36px',
  opacity: "0.5",
  fontFamily: "Lato",
  fontSize: "13px",
  fontWeight: "normal",
  fontStretch: "normal",
  fontStyle: "normal",
  lineHeight: "normal",
  letterSpacing: "0.09px",
  textAlign: "center",
  color: "#333",
});

const UpButton = styled(Button)({
  "&:disabled": {
    backgroundColor: "#339aef",
    opacity: "0.5",
    color: "#fff",
  },
  borderRadius: "0px",
  height: "50px",
  boxShadow: "none",
  textTransform: "none",
  fontFamily: "Montserrat, sans-serif",
  fontSize: "12px",
  fontWeight: "600",
  fontStretch: "normal",
  fontStyle: "normal",
  lineHeight: "normal",
  letterSpacing: "0.09px",
  textAlign: "center",
  color: "#fff",
  backgroundColor: "#339aef",
  "&:hover": {
    backgroundColor: "#339aef",
  },
  "&:active": {
    backgroundColor: "#339aef",
  },
  "&:focus": {
    backgroundColor: "#339aef",
  },
});

const BackButton = styled(Button)({
  borderRadius: "0px",
  height: "50px",
  boxShadow: "none",
  textTransform: "none",
  fontFamily: "Montserrat, sans-serif",
  fontSize: "12px",
  fontWeight: "600",
  fontStretch: "normal",
  fontStyle: "normal",
  lineHeight: "normal",
  letterSpacing: "0.09px",
  textAlign: "center",
  color: "#fff",
  backgroundColor: "#4d606f",
  "&:hover": {
    backgroundColor: "#4d606f",
  },
  "&:active": {
    backgroundColor: "#4d606f",
  },
  "&:focus": {
    backgroundColor: "#4d606f",
  },
});

const SimpleBox = styled(Box)({
  textAlign: "center",
  marginTop: '3px',
});


const Resend = styled(Button)({
  fontFamily: 'Lato',
  fontSize: '14px',
  fontWeight: 'bold',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: 'normal',
  letterSpacing: '0.1px',
  color: '#339aef',
  textTransform: 'none'
});

const CssTextField = styled(TextField)({
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      height: "45px",
      border: "solid 1px #ccc",
    },
    "& input": {
      padding: "12px",
    },
  },
});

const CompilaCampi = styled(Box)({
  marginTop: "10px",
  fontFamily: "Lato",
  fontSize: "15px",
  fontWeight: "normal",
  fontStretch: "normal",
  fontStyle: "normal",
  lineHeight: "normal",
  letterSpacing: "0.11px",
  textAlign: "center",
  color: "#7b7b7b",
});

const Intestazione = styled(Box)({
  fontFamily: "Montserrat, sans-serif",
  fontSize: "31px",
  fontWeight: "normal",
  fontStretch: "normal",
  fontStyle: "normal",
  lineHeight: "normal",
  letterSpacing: "normal",
  textAlign: "center",
  color: "#1b1b1b",
});

const Otp = styled(Box)({
  fontFamily: 'Lato',
  fontSize: '18px',
  fontWeight: 'normal',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: 'normal',
  letterSpacing: '0.13px',
  textAlign: 'center',
  color: '#4d606f'
});

const Otptext = styled(Box)({
  fontFamily: 'Lato',
  fontSize: '18px',
  fontWeight: 'bold',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: 'normal',
  letterSpacing: '0.13px',
  textAlign: 'center',
  color: '#4d606f'
});

const Buttons = styled(Grid)({
  marginTop: '34px',
  marginBottom: '50px'
});

const ErrorOtp = styled(Box)({
  fontFamily: 'Lato',
  fontSize: '10px',
  fontWeight: 'bold',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: 'normal',
  letterSpacing: '0.13px',
  textAlign: 'center',
  color: 'red'
})

function OtpForm() {
  const [loading, setloading] = useState(false);
  let history = useNavigate();
  const [OTPsms, setOTPsmsinput] = useState("");
  const [OTPemail, setOTPemailinput] = useState("");
  const [isDisabled, setDisabled] = useState(true);
  const RESEND_REST_API_URL = Url + "api/otpresend";
  const VERIFY_REST_API_URL = Url + "api/otpverify/" + OTPemail + "/" + OTPsms;
  const { getStore, addStore, getStoreAsync } = useSharedStore();
  const [verifyResponse, setverifyResponse] = useState("");
  const [OTPresponse, setOTPresponse] = useState("");
  const [email, setEmail] = useState("");
  const [number, setNumber] = useState("");

  const resend = () => {
    setloading(true);
    axios.get(RESEND_REST_API_URL, {
      headers: {
        'Authorization': getStore("token")
      }
    }).then(res => {
      setloading(false);
      setOTPresponse("");
      if (res.data.response_code != "CR_2_33" || res.data.response_data == null) {
        setOTPresponse(res.data.response_desc);
      }
    });
  }

  const verifyOtp = () => {
    setloading(true);
    axios.get(VERIFY_REST_API_URL, {
      headers: {
        'Authorization': getStore("token")
      }
    }).then(res => {
      setloading(false);
      setverifyResponse("");
      switch (res.data.response_code) {
        case "CR_2_30":
          addStore("token", res.data.response_data);
          history("/printcodeform");
          break;
        case "CR_2_30b":
          addStore("token", res.data.response_data);
          history("/selectuser");
          break;
        default:
          setverifyResponse(res.data.response_desc);
          break;
      }
    });
  }

  const otpInfo = () => {
    setloading(true);
    getStoreAsync("token").then(val => {
      axios.get(Url + "api/otpinfo", {
        headers: {
          'Authorization': val
        }
      }).then(res => {
        setloading(false);
        setNumber(res.data.response_data.number);
        setEmail(res.data.response_data.email);
      });
    });
  }

  useEffect(() => {
    setloading(false);
    window.scrollTo(0, 0);
    otpInfo();
  }, []);

  function checkforDisable() {
    if (OTPsms == "" || OTPemail == "") {
      return true;
    } else {
      return false;
    }
  }

  const date = new Date();
  const currentYear = date.getFullYear();

  return (
    <Container maxWidth="1">
      <Grid container>
        <Grid class="logoContainer" item xs={12} sm={12} md={12}>
          <img class="logo" src={Sella}></img>
        </Grid>
      </Grid>
      <br></br>
      <br></br>
      <br></br>
      <br></br>
      <Grid container>
        <Grid item xs={12} sm={12} md={12}>
          <Intestazione>Recupera il tuo Codice Cliente o Username</Intestazione>
        </Grid>
      </Grid>
      <Grid container>
        <Grid item xs={12} sm={12} md={12}>
          <CompilaCampi>
            Compila i campi per recuperare il Codice Cliente o Username
          </CompilaCampi>
        </Grid>
      </Grid>

      <Grid container>
        <Grid item xs={0} sm={0} md={3}></Grid>
        <Grid item xs={12} sm={12} md={6}>
          <div class="Line-8"></div>
        </Grid>
        <Grid item xs={0} sm={0} md={3}></Grid>
      </Grid>

      <Grid container>
        <Grid item xs={0} sm={0} md={3}></Grid>
        <Grid item xs={12} sm={12} md={6}>
          <Otp>
            Inserisci i due codici OTP (6 cifre) che abbiamo inviato ai seguenti recapiti:<br></br>
            Numero di cellulare:<Otptext component="span">{number}</Otptext><br></br>
            Email:<Otptext component="span">{email}</Otptext>
          </Otp>
        </Grid>
        <Grid item xs={0} sm={0} md={3}></Grid>
      </Grid>
      <br></br>
      <Grid container spacing={4}>
        <Grid item xs={0} sm={0} md={4}></Grid>
        <Grid item xs={12} sm={12} md={4}>
          <FormControl variant="standard" fullWidth>
            <InputLabel class="Lable" htmlFor="Otp-input">
              OTP Sms
            </InputLabel>
            <CssTextField
              onChange={(e) => setOTPsmsinput(e.target.value.trim())}
              variant="outlined"
              fullWidth
              type="text"
              defaultValue=""
              id="Otp-input"
            />
          </FormControl>
        </Grid>
        <Grid item xs={0} sm={0} md={4}></Grid>
      </Grid>

      <Grid container spacing={4}>
        <Grid item xs={0} sm={0} md={4}></Grid>
        <Grid item xs={12} sm={12} md={4}>
          <FormControl variant="standard" fullWidth>
            <InputLabel class="Lable" htmlFor="Otp-input">
              OTP Email
            </InputLabel>
            <CssTextField
              onChange={(e) => setOTPemailinput(e.target.value.trim())}
              variant="outlined"
              fullWidth
              type="text"
              defaultValue=""
              id="Otp-input"
            />
          </FormControl>
        </Grid>
        <Grid item xs={0} sm={0} md={4}></Grid>
      </Grid>

      <Grid container>
        <Grid item xs={12} sm={12} md={12}>
          <SimpleBox>
            <ErrorOtp dangerouslySetInnerHTML={{ __html: OTPresponse }}>

            </ErrorOtp>
          </SimpleBox>
        </Grid>
      </Grid>

      <Buttons container>
        <Grid item xs={12} sm={12} md={12}>
          <SimpleBox>
            <Resend
              disabled={loading}
              onClick={resend}
            >Reinvia gli OTP (sia sms che email)</Resend>
          </SimpleBox>
        </Grid>
      </Buttons>

      <Grid container spacing={1}>
        <Grid item xs={0} sm={0} md={4}></Grid>
        <Grid item xs={12} sm={12} md={2}>
          <BackButton
            fullWidth
            disabled={loading}
            variant="contained"
            onClick={() => history(-1)}
          >
            INDIETRO
          </BackButton>
        </Grid>
        <Grid item xs={12} sm={12} md={2}>
          <UpButton
            onClick={verifyOtp}
            fullWidth
            variant="contained"
            disabled={checkforDisable() || loading}
          >
            PROSEGUI
          </UpButton>
        </Grid>
      </Grid>
      <br></br>
      <br></br>
      <Grid container>
        <Grid item xs={12} sm={12} md={12}>
          <SimpleBox>
            <ErrorOtp dangerouslySetInnerHTML={{ __html: verifyResponse }}>
            </ErrorOtp>
          </SimpleBox>
        </Grid>
      </Grid>

      <Grid container>
        <Grid item xs={12} sm={12} md={12}>
          <HelperText>
            Vuoi maggiori informazioni o hai bisogno di assistenza?
          </HelperText>
        </Grid>
      </Grid>

      <Grid container>
        <Grid item xs={12} sm={12} md={12}>
          <SimpleBox>
            <ContactLink href="/banca-on-line/contatti-e-assistenza">contatta il servizio clienti</ContactLink>
          </SimpleBox>
        </Grid>
      </Grid>

      <Grid container>
        <Grid item xs={0} sm={0} md={3}></Grid>
        <Grid item xs={12} sm={12} md={6}>
          <div class="Line-1"></div>
        </Grid>
        <Grid item xs={0} sm={0} md={3}></Grid>
      </Grid>

      <Grid container>
        <Grid item xs={12} sm={12} md={12}>
          <Informativa>
            © 1996-{currentYear} - Banca Sella S.p.A. - PI 02224410023 - Privacy
          </Informativa>
        </Grid>
      </Grid>
    </Container>
  );
}

export default OtpForm;